// eslint-disable-next-line no-unused-vars
import { Address } from '@clients/myTrips'

export default function addressFormat (address: Address) {
  return `${address.streetLine}, ${address.areaCode} ${address.locality}`
}
